import { setAssetReferenceData } from '../dataSetters'

export const mapAssetReferences = ({ assets, coverAssets }) =>
  assets.map((entry) => {
    const coverAsset = coverAssets?.find(
      (asset) =>
        asset?.id === entry.attributes?.cover_asset_reference?.id ||
        asset?.id === entry.asset_reference?.cover_asset_reference_id
    )
    if (coverAsset) {
      return {
        ...setAssetReferenceData(entry.asset_reference || entry.attributes),
        caption: entry.caption,
        position: entry.position,
        cover_asset_reference: coverAsset
          ? setAssetReferenceData(coverAsset)
          : {},
      }
    } else {
      return {
        ...setAssetReferenceData(entry.asset_reference || entry.attributes),
        caption: entry.caption,
        position: entry.position,
      }
    }
  })
